import { resolveHubupAssetUrl } from '../api/hubup';

/** Opacité du fond de carte communauté (aligné hubupfront). */
export const GROUP_FEED_BRAND_BG_ALPHA = 0.14;

function expandHex(hex) {
  const h = hex.replace(/^#/, '');
  if (h.length === 3) {
    return h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (h.length === 4) {
    return h
      .split('')
      .map((c) => c + c)
      .join('')
      .slice(0, 6);
  }
  return h.slice(0, 6);
}

export function hexToRgba(hex, alpha) {
  const raw = expandHex(hex);
  const r = parseInt(raw.slice(0, 2), 16);
  const g = parseInt(raw.slice(2, 4), 16);
  const b = parseInt(raw.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function cssFontFamilyStack(font) {
  const t = font.trim();
  if (!t) return '';
  if (t.includes(',')) return t;
  if (/^["']/.test(t)) return t;
  return `"${t}", sans-serif`;
}

export function notificationFeedBrandStyles(brand) {
  const font = brand.groupFeedFont?.trim();
  if (!font) return { active: false };

  const fontFamily = cssFontFamilyStack(font);
  const textStyle = { fontFamily };
  const contentFontStyle = { fontFamily };

  if (brand.groupColorHexFont?.trim()) {
    textStyle.color = brand.groupColorHexFont.trim();
    contentFontStyle.color = brand.groupColorHexFont.trim();
  }

  let cardStyle;
  let fadeFromRgba;
  if (brand.groupColorHexBg?.trim()) {
    const bg = brand.groupColorHexBg.trim();
    cardStyle = {
      backgroundColor: hexToRgba(bg, GROUP_FEED_BRAND_BG_ALPHA),
    };
    fadeFromRgba = hexToRgba(bg, GROUP_FEED_BRAND_BG_ALPHA);
  }

  return {
    active: true,
    cardStyle,
    textStyle,
    contentFontStyle,
    fadeFromRgba,
  };
}

/** Classes typographie fil d’annonces (taille standard = md). */
export const HUBUP_NOTIF_FEED_SIZE_MD = {
  feedName: 'text-[14px]',
  title: 'text-[18px] leading-snug',
  bodyPlain: 'text-[15px] text-[#333483] mt-1 leading-relaxed',
  rich:
    'notif-rich-body max-w-none break-words text-[15px] leading-relaxed [&_p]:!text-inherit [&_li]:!text-inherit [&_h1]:!text-inherit [&_h2]:!text-inherit [&_h3]:!text-inherit [&_p]:my-1 [&_ul]:my-1 [&_ol]:my-1 [&_a]:break-all [&_a]:!text-[#333483] [&_a]:font-bold [&_strong]:!text-[#1E1B4B]/90',
};

export function sanitizeNotificationDisplayText(input) {
  if (!input || typeof input !== 'string') return input || '';
  let s = input.replace(/^\s*url\s*:\s*/gim, '');
  s = s
    .split('\n')
    .map((line) => {
      if (!/https?:\/\//i.test(line)) return line;
      return line.replace(/\s*:+\s*$/g, '').replace(/\s+$/, '');
    })
    .join('\n');
  return s.trim();
}

/** Affichage HTML issu de l’éditeur CRM (aperçu). */
export function sanitizeRichBodyHtmlForPreview(html) {
  const raw = String(html || '');
  if (!raw.trim()) return '';
  let out = raw
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*(".*?"|'.*?'|[^\s>]+)/gi, '');
  if (/<img\b/i.test(out)) {
    out = out.replace(
      /(<img\b[^>]*\ssrc\s*=\s*)(["'])([^"']+)\2/gi,
      (_m, pre, q, src) => {
        const resolved = resolveHubupAssetUrl(String(src).trim());
        if (!resolved || /^javascript:/i.test(resolved)) {
          return `${pre}${q}${q}`;
        }
        return `${pre}${q}${resolved}${q}`;
      },
    );
  }
  return out;
}
